import React, { FC, useEffect } from 'react';

import Modal from '~components/atoms/Modal';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import GoldTransactionDetails from '../GoldConversionDetails';
import GoldConversionDetails from '../GoldConversionDetails';

type GoldConversionDetailsModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const GoldConversionDetailsModal: FC<GoldConversionDetailsModalProps> = ({
    isOpen,
    onClose,
}) => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isOpen) {
            dispatch(combinedActions.goldClearSellOrBuyGoldParams());
        }
    }, [isOpen]);

    return (
        <Modal
            testId='transaction-product-details-summary-modal-close'
            isOpen={isOpen}
            onClose={onClose}
            title='Conversion Summary Details'
        >
            <GoldConversionDetails />
        </Modal>
    );
};

export default GoldConversionDetailsModal;
